export const formatter = (data = []) => {
  const result = [];

  data.forEach((c) => {
    result.push({
      name: `${c.title} ${c.firstName} ${c.lastName}`,
      code: c.code,
      role: c.role,
      institution: c.institution,
      email: c.emailAddress,
      phoneNumber: c.phoneNumber,
    });
  });

  return result;
};
